const tempDiv = document.createElement('div');
tempDiv.id = 'overflow-check';
tempDiv.style.cssText = `
  width: max-content;
  position: absolute;
  visibility: hidden;
  top: -9999px;
  left: -9999px;
  pointer-events: none;
`;
document.body.appendChild(tempDiv);

/*
  Utility function to check if an element is overflown;

  It handles Chrome-specific case where scrollWidth & clientWidth are equal because of rounded pixel values.
 */
export const checkOverflow = (element?: Element | null) => {
  if (!element) {
    return false;
  }

  if (element.scrollWidth > element.clientWidth) {
    return true;
  }

  tempDiv.replaceChildren(element.cloneNode(true));
  const styles = getComputedStyle(element);
  const clone = tempDiv.firstElementChild as HTMLElement;

  clone.style.cssText =
    styles.cssText !== ''
      ? styles.cssText
      : Array.from(styles).reduce(
          (css, propertyName) => `${css}${propertyName}:${styles.getPropertyValue(propertyName)};`,
          ''
        );
  clone.style.minWidth = 'unset';
  clone.style.maxWidth = 'unset';
  clone.style.width = 'max-content';

  return clone.getBoundingClientRect().width > element.getBoundingClientRect().width;
};

// Checks overflow for multi-line clamped elements by comparing natural height to clamped height.
export const checkLineClampOverflow = (element?: Element | null, lineClamp = 1) => {
  if (!element) {
    return false;
  }

  if (!Number.isFinite(lineClamp) || lineClamp <= 1) {
    return checkOverflow(element);
  }

  tempDiv.replaceChildren(element.cloneNode(true));
  const styles = getComputedStyle(element);
  const clone = tempDiv.firstElementChild as HTMLElement;

  clone.style.cssText =
    styles.cssText !== ''
      ? styles.cssText
      : Array.from(styles).reduce(
          (css, propertyName) => `${css}${propertyName}:${styles.getPropertyValue(propertyName)};`,
          ''
        );

  const {width} = element.getBoundingClientRect();

  clone.style.width = `${width}px`;
  clone.style.minHeight = 'unset';
  clone.style.maxHeight = 'unset';
  clone.style.height = 'max-content';

  clone.style.setProperty('-webkit-line-clamp', 'unset');
  clone.style.setProperty('-webkit-box-orient', 'unset');

  const unclampedHeight = clone.getBoundingClientRect().height;
  const clampedHeight = element.getBoundingClientRect().height;

  return unclampedHeight - clampedHeight > 0.5;
};
